
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import { isForeign, iDCardTypesLabel } from 'components/InvestorInfo/common/investorConfig'
import bingListenScroll from '../../../common/js/isReachBottom'
export default {
props: {
propData: {
type: [Object]
},
baseInfo: {
type: [Object]
},
hasResp: {
type: [Boolean],
default: false
}
},
components: {
Loading,
Group,
XHeader,
XInput,
Selector,
XNumber,
Datetime,
XButton,
Icon,
Checker,
CheckerItem,
XTextarea
},
data () {
return {
isReady: true,
data: {
userInvestmentExperience: {
checked: ''
},
userAssetsScale: {
checked: ''
},
isControllingShareholder: {
checked: '',
description: ''
},
transactionActualBeneficiary: {
checked: '',
description: ''
},
isBadFaith: {
checked: '',
description: ''
}
}
}
},
computed: {

isFund () {
return this.baseInfo.orgType !== 'futures'
}
},
created () {
bingListenScroll(this)
},
mounted () {
},
watch: {
hasResp (bool) {
if (bool) {
this.$_personal_init()
}
}
},
methods: {
isForeign,
iDCardTypesLabel,
$_personal_init () {
this.data.userInvestmentExperience.checked = parseInt(this.baseInfo.isNormal) === 1 ? '否' : '是'
if (this.propData.oldInfo) {
let res = JSON.parse(this.propData.oldInfo)
this.data = {
userInvestmentExperience: {
checked: JSON.parse(res.userInvestmentExperience).checked
},
userAssetsScale: {
checked: JSON.parse(res.userAssetsScale).checked
},
isControllingShareholder: {
checked: JSON.parse(res.isControllingShareholder).checked,
description: JSON.parse(res.isControllingShareholder).description
},
transactionActualBeneficiary: {
checked: JSON.parse(res.transactionActualBeneficiary).checked,
description: JSON.parse(res.transactionActualBeneficiary).description
},
isBadFaith: {
checked: JSON.parse(res.isBadFaith).checked,
description: JSON.parse(res.isBadFaith).description
}
}
}
},


$_personal_submit () {
let subObj = Object.assign({}, this.data, this.propData)
delete subObj.oldInfo
delete subObj.type
delete subObj.isNormal
this.$_personal_commit(subObj)
},

$_personal_commit (json) {
console.log(JSON.stringify(json))
if (!this.isDev) {
console.log('submit')
this.$bridge.callHandler('getResult', {message: '最后确认', json: JSON.stringify(json)}, function (data) {

})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Personal/OneLook.vue